import React, { Component } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Divider,
  Header,
  Menu,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import { AutoSizer } from "react-virtualized";

class WelcomeView extends Component {
  render() {
    const { t } = this.props;

    return (
      <AutoSizer disableHeight style={{ display: "flex", flex: 1 }}>
        {({ width }) => {
          let Wrapper = Container;
          let style = {};

          if (width < 764) {
            Wrapper = "div";
            style = {
              margin: 0,
              width,
            };
          }

          return (
            <Wrapper style={style}>
              <Menu
                inverted
                style={{
                  backgroundColor: "#136444",
                  borderRadius: 0,
                  margin: 0,
                }}
              >
                <Menu.Item name="inicio" active={true} />
                <Menu.Item name="nosotros" active={false} />
              </Menu>

              <Segment vertical secondary style={{ padding: 4 }}>
                <Breadcrumb>
                  <Breadcrumb.Section active>Inicio</Breadcrumb.Section>
                </Breadcrumb>
              </Segment>

              <Header as="h3">
                <Header.Content>
                  Bienvenido
                  <Header.Subheader>Alquiler de canchas</Header.Subheader>
                </Header.Content>
              </Header>

              <Divider />

              <Segment size="small" textAlign="center" vertical>
                <Header>
                  {`Para reservar una cancha comenza por`.toUpperCase()}
                </Header>
                <Button
                  as={Link}
                  content="INGRESAR"
                  primary
                  size="huge"
                  to="/sign-in"
                />
              </Segment>
            </Wrapper>
          );
        }}
      </AutoSizer>
    );
  }
}

const i18nEnhancement = translate("translations")(WelcomeView);

export default i18nEnhancement;



// WEBPACK FOOTER //
// ./src/components/views/WelcomeView.jsx